// src/services/index.js   (o el path donde lo tengas)
import axios from "axios";
export * from "./logger.js";
export * from "./index.js"; // si este apunta al anterior, déjalo. Si crea bucles, elimina esta línea.

const HOST =
  typeof window !== "undefined" ? window.location.hostname : "";
const IS_LOCAL = HOST === "localhost" || HOST === "127.0.0.1";

function getServerUrl() {
  if (typeof window !== "undefined" && window.__API_URL__) {
    return window.__API_URL__;
  }

  if (IS_LOCAL) return "http://localhost:4001";
  if (HOST.endsWith("owius.com")) return "https://cobega-api.evenely.com";
  return "https://cobega-api.evenely.com";
}

function getFrontUrl() {
  if (typeof window !== "undefined" && window.__FRONT_URL__) {
    return window.__FRONT_URL__;
  }

  if (IS_LOCAL) return "http://localhost:3000"; // CRA por defecto; ajusta si usas otro puerto
  if (HOST.endsWith("owius.com")) return "https://cobega-api.evenely.com";
  return "https://cobega-api.evenely.com";
}

export const SERVER_URL = getServerUrl();
export const FRONT_URL  = getFrontUrl();
export const API        = `${SERVER_URL}/api`;

export const baseClient = () =>
  axios.create({ baseURL: API });

export const authClient = () =>
  axios.create({ baseURL: API, withCredentials: true });
